import React, { memo, useCallback } from 'react';
import { FormSelect } from '@core/components/form';
import { useBloc } from '@core/utils/bloc';
import { LibraryCustomWidgetForm, LibraryCustomBlockVariation } from './LibraryCustomBlock';
import { LibraryCustomBlockBloc } from './LibraryCustomBlockBloc';
import { R } from '@core/utils/r';
import { CompactLibraryItemResponse, LibraryItemOptionResponse } from '@business/entities/library';
import { useLibraryItemSelect } from '../Common/LibraryItemSelect';

export interface LibraryCustomBlockSettingsProps {
  form: LibraryCustomWidgetForm;
  variation: LibraryCustomBlockVariation;
}

export const LibraryCustomBlockSettings = memo((props: LibraryCustomBlockSettingsProps) => {
  const { form, variation } = props;
  const bloc = useBloc(LibraryCustomBlockBloc, variation);

  const apply = useCallback(
    (item: CompactLibraryItemResponse, option: LibraryItemOptionResponse) => {
      form.patchValue({ text: item.content as string, heading: option.name, fields: JSON.stringify(R.get(item, 'fields')) });
    },
    [form],
  );

  const { items, onChange, noOptionsMessage } = useLibraryItemSelect(bloc, form.controls.id, 'library items', apply);

  return (
    <div>
      <FormSelect control={form.controls.id} items={items} onChange={onChange} noOptionsMessage={noOptionsMessage} />
    </div>
  );
});
